import type { RouteRecordRaw } from 'vue-router';

export const cTEMA_VENDAS_ROUTES = {
  //Raiz do módulo
  name: 'TemaVendas',
  path: 'vendas',
  component: () => import('@/modules/temas/tema-vendas/LayoutTemaVendas.vue'),

  Pedidos: {
    name: 'PedidosTemaVendas',
    path: 'pedidos',

    VisaoGeral: {
      name: 'VisaoGeralPedidosTemaVendas',
      path: 'visao-geral',
      component: () => import('@/modules/temas/tema-vendas/pages/pedidos/visao-geral/VisaoGeralPedidosTemaVendas.vue'),
    },

    AnaliseGeografica: {
      name: 'AnaliseGeograficaPedidosTemaVendas',
      path: 'analise-geografica',
      component: () =>
        import('@/modules/temas/tema-vendas/pages/pedidos/analise-geografica/AnaliseGeograficaPedidosTemaVendas.vue'),
    },

    MetaVendas: {
      name: 'MetaVendasPedidosTemaVendas',
      path: 'meta',

      Especifico: {
        path: 'especifico',
        name: 'MetaEspecificoVendasPedidosTemaVendas',

        MetaPorConsultor: {
          path: 'consultor',
          name: 'MetaVendasPedidosEspecificoPorConsultor',
          component: () =>
            import(
              '@/modules/temas/tema-vendas/pages/pedidos/meta-vendas/MetaEspecificaPedidosConsultorTemaVendas.vue'
            ),
        },

        MetaPorSupervisor: {
          path: 'supervisor',
          name: 'MetaVendasPedidosEspecificoPorSupervisor',
          component: () =>
            import(
              '@/modules/temas/tema-vendas/pages/pedidos/meta-vendas/MetaEspecificaPedidosSupervisorTemaVendas.vue'
            ),
        },
      },

      Geral: {
        path: 'geral',
        name: 'MetaGeralVendasPedidosTemaVendas',

        MetaPorConsultor: {
          path: 'consultor',
          name: 'MetaVendasGeralPedidosPorConsultor',
          component: () =>
            import('@/modules/temas/tema-vendas/pages/pedidos/meta-vendas/MetaGeralPedidosConsultorTemaVendas.vue'),
        },

        MetaPorSupervisor: {
          path: 'supervisor',
          name: 'MetaVendasGeralPedidosPorSupervisor',
          component: () =>
            import('@/modules/temas/tema-vendas/pages/pedidos/meta-vendas/MetaGeralPedidosSupervisorTemaVendas.vue'),
        },
      },
    },

    Ranking: {
      name: 'RankingPedidosTemaVendas',
      path: 'ranking',

      Geral: {
        path: 'geral',
        name: 'RankingGeralPedidosTemaVendas',
        component: () => import('@/modules/temas/tema-vendas/pages/pedidos/ranking/RankingGeralPedidosTemaVendas.vue'),
      },

      Itens: {
        path: 'itens',
        name: 'RankingItensPedidosTemaVendas',
        component: () => import('@/modules/temas/tema-vendas/pages/pedidos/ranking/RankingItensPedidosTemaVendas.vue'),
      },
    },

    Acompanhamento: {
      path: 'acompanhamento',
      name: 'AcompanhamentoPedidosTemaVendas',

      Diario: {
        name: 'AcompanhamentoDiarioPedidosTemaVendas',
        path: 'diario',
        component: () =>
          import('@/modules/temas/tema-vendas/pages/pedidos/acompanhamento/AcompanhamentoDiarioPedidosTemaVendas.vue'),
      },

      Semanal: {
        name: 'AcompanhamentoSemanalPedidosTemaVendas',
        path: 'semanal',
        component: () =>
          import('@/modules/temas/tema-vendas/pages/pedidos/acompanhamento/AcompanhamentoSemanalPedidosTemaVendas.vue'),
      },

      Quinzenal: {
        name: 'AcompanhamentoQuinzenalPedidosTemaVendas',
        path: 'quinzenal',
        component: () =>
          import('@/modules/temas/tema-vendas/pages/pedidos/acompanhamento/AcompanhamentoQuinzenalPedidosTemaVendas.vue'),
      },

      Mensal: {
        name: 'AcompanhamentoMensalPedidosTemaVendas',
        path: 'mensal',
        component: () =>
          import('@/modules/temas/tema-vendas/pages/pedidos/acompanhamento/AcompanhamentoMensalPedidosTemaVendas.vue'),
      },

      Trimestral: {
        name: 'AcompanhamentoTrimestralPedidosTemaVendas',
        path: 'trimestral',
        component: () =>
          import(
            '@/modules/temas/tema-vendas/pages/pedidos/acompanhamento/AcompanhamentoTrimestralPedidosTemaVendas.vue'
          ),
      },

      Semestral: {
        name: 'AcompanhamentoSemestralPedidosTemaVendas',
        path: 'semestral',
        component: () =>
          import(
            '@/modules/temas/tema-vendas/pages/pedidos/acompanhamento/AcompanhamentoSemestralPedidosTemaVendas.vue'
          ),
      },

      Anual: {
        name: 'AcompanhamentoAnualPedidosTemaVendas',
        path: 'anual',
        component: () =>
          import('@/modules/temas/tema-vendas/pages/pedidos/acompanhamento/AcompanhamentoAnualPedidosTemaVendas.vue'),
      },
    },

    Evolucao: {
      name: 'EvolucaoPedidosTemaVendas',
      path: 'evolucao',
      component: () => import('@/modules/temas/tema-vendas/pages/pedidos/evolucao/EvolucaoPedidosTemaVendas.vue'),
    },

    CarteiraDeClientes: {
      name: 'CarteiraClientesTemaVendas',
      path: 'carteira',
      component: () =>
        import('@/modules/temas/tema-vendas/pages/pedidos/carteira-clientes/CarteiraDeClientesTemaVendas.vue'),
    },

    FaturadosDevolvidosCancelados: {
      name: 'FaturadosDevolvidosCanceladosTemaVendas',
      path: 'fatdevcanc',
      component: () =>
        import(
          '@/modules/temas/tema-vendas/pages/pedidos/faturados-devolvidos-cancelados/FaturadosDevolvidosCanceladosTemaVendas.vue'
        ),
    },

    CurvaABC: {
      name: 'CurvaABCTemaVendas',
      path: 'curva-abc',
      component: () => import('@/modules/temas/tema-vendas/pages/pedidos/curva-abc/CurvaAbcTemaVendas.vue'),
    },
  },

  Assistencias: {
    name: 'AssistenciasTemaVendas',
    path: 'assistencias',

    VisaoGeral: {
      path: 'visao-geral',
      name: 'VisaoGeralAssistenciasTemaVendas',
      component: () =>
        import('@/modules/temas/tema-vendas/pages/assistencias/visao-geral/VisaoGeralAssistenciasTemaVendas.vue'),
    },

    ComparativoVendasxAssistencias: {
      path: 'comparativo',
      name: 'ComparativoVendasxAssistenciasTemaVendas',
      component: () =>
        import(
          '@/modules/temas/tema-vendas/pages/assistencias/comparativo-vendas-assistencias/ComparativoVendasAssistenciasTemaVendas.vue'
        ),
    },

    AnaliseGeografica: {
      name: 'AnaliseGeograficaAssistenciasTemaVendas',
      path: 'analise-geografica',
      component: () =>
        import(
          '@/modules/temas/tema-vendas/pages/assistencias/analise-geografica/AnaliseGeograficaAssistenciasTemaVendas.vue'
        ),
    },

    MetaVendas: {
      name: 'MetaVendasAssistenciasTemaVendas',
      path: 'meta',

      Especifico: {
        path: 'especifico',
        name: 'MetaEspecificoVendasAssistenciasTemaVendas',

        MetaPorConsultor: {
          path: 'consultor',
          name: 'MetaVendasAssistenciasEspecificoPorConsultor',
          component: () =>
            import(
              '@/modules/temas/tema-vendas/pages/assistencias/meta-vendas/MetaEspecificaAssistenciasConsultorTemaVendas.vue'
            ),
        },

        MetaPorSupervisor: {
          path: 'supervisor',
          name: 'MetaVendasAssistenciasEspecificoPorSupervisor',
          component: () =>
            import(
              '@/modules/temas/tema-vendas/pages/assistencias/meta-vendas/MetaEspecificaAssistenciasSupervisorTemaVendas.vue'
            ),
        },
      },

      Geral: {
        path: 'geral',
        name: 'MetaGeralVendasAssistenciasTemaVendas',

        MetaPorConsultor: {
          path: 'consultor',
          name: 'MetaVendasGeralAssistenciasPorConsultor',
          component: () =>
            import(
              '@/modules/temas/tema-vendas/pages/assistencias/meta-vendas/MetaGeralAssistenciasConsultorTemaVendas.vue'
            ),
        },

        MetaPorSupervisor: {
          path: 'supervisor',
          name: 'MetaVendasGeralAssistenciasPorSupervisor',
          component: () =>
            import(
              '@/modules/temas/tema-vendas/pages/assistencias/meta-vendas/MetaGeralAssistenciasSupervisorTemaVendas.vue'
            ),
        },
      },
    },
  },

  Personalizado: {
    path: 'personalizado',
    name: 'PersonalizadoTemaVendas',

    Gerenciador: {
      path: 'gerenciador',
      name: 'GerenciadorPersonalizadoTemaVendas',
      component: () => import('@/modules/temas/tema-vendas/pages/personalizado/GerenciadorPersonalizadoTemaVendas.vue'),
    },

    Dashboard: {
      props: true,
      path: 'dashboard/:idMenu?',
      name: 'DashboardPersonalizadoTemaVendas',
      component: () =>
        import('@/modules/temas/tema-vendas/pages/personalizado/LayoutDashboardPersonalizadoTemaVendas.vue'),
    },
  },
};

export const rotasTemaVendas: Array<RouteRecordRaw> = [
  {
    path: cTEMA_VENDAS_ROUTES.path,
    name: cTEMA_VENDAS_ROUTES.name,
    component: cTEMA_VENDAS_ROUTES.component,
    children: [
      {
        name: cTEMA_VENDAS_ROUTES.Pedidos.name,
        path: cTEMA_VENDAS_ROUTES.Pedidos.path,
        redirect: { name: cTEMA_VENDAS_ROUTES.Pedidos.VisaoGeral.name },
        children: [
          {
            name: cTEMA_VENDAS_ROUTES.Pedidos.VisaoGeral.name,
            path: cTEMA_VENDAS_ROUTES.Pedidos.VisaoGeral.path,
            component: cTEMA_VENDAS_ROUTES.Pedidos.VisaoGeral.component,
          },

          {
            name: cTEMA_VENDAS_ROUTES.Pedidos.AnaliseGeografica.name,
            path: cTEMA_VENDAS_ROUTES.Pedidos.AnaliseGeografica.path,
            component: cTEMA_VENDAS_ROUTES.Pedidos.AnaliseGeografica.component,
          },

          {
            name: cTEMA_VENDAS_ROUTES.Pedidos.MetaVendas.name,
            path: cTEMA_VENDAS_ROUTES.Pedidos.MetaVendas.path,
            children: [
              {
                name: cTEMA_VENDAS_ROUTES.Pedidos.MetaVendas.Especifico.name,
                path: cTEMA_VENDAS_ROUTES.Pedidos.MetaVendas.Especifico.path,
                children: [
                  {
                    name: cTEMA_VENDAS_ROUTES.Pedidos.MetaVendas.Especifico.MetaPorConsultor.name,
                    path: cTEMA_VENDAS_ROUTES.Pedidos.MetaVendas.Especifico.MetaPorConsultor.path,
                    component: cTEMA_VENDAS_ROUTES.Pedidos.MetaVendas.Especifico.MetaPorConsultor.component,
                  },

                  {
                    name: cTEMA_VENDAS_ROUTES.Pedidos.MetaVendas.Especifico.MetaPorSupervisor.name,
                    path: cTEMA_VENDAS_ROUTES.Pedidos.MetaVendas.Especifico.MetaPorSupervisor.path,
                    component: cTEMA_VENDAS_ROUTES.Pedidos.MetaVendas.Especifico.MetaPorSupervisor.component,
                  },
                ],
              },

              {
                name: cTEMA_VENDAS_ROUTES.Pedidos.MetaVendas.Geral.name,
                path: cTEMA_VENDAS_ROUTES.Pedidos.MetaVendas.Geral.path,
                children: [
                  {
                    name: cTEMA_VENDAS_ROUTES.Pedidos.MetaVendas.Geral.MetaPorConsultor.name,
                    path: cTEMA_VENDAS_ROUTES.Pedidos.MetaVendas.Geral.MetaPorConsultor.path,
                    component: cTEMA_VENDAS_ROUTES.Pedidos.MetaVendas.Geral.MetaPorConsultor.component,
                  },

                  {
                    name: cTEMA_VENDAS_ROUTES.Pedidos.MetaVendas.Geral.MetaPorSupervisor.name,
                    path: cTEMA_VENDAS_ROUTES.Pedidos.MetaVendas.Geral.MetaPorSupervisor.path,
                    component: cTEMA_VENDAS_ROUTES.Pedidos.MetaVendas.Geral.MetaPorSupervisor.component,
                  },
                ],
              },
            ],
          },

          {
            name: cTEMA_VENDAS_ROUTES.Pedidos.Ranking.name,
            path: cTEMA_VENDAS_ROUTES.Pedidos.Ranking.path,
            children: [
              {
                name: cTEMA_VENDAS_ROUTES.Pedidos.Ranking.Geral.name,
                path: cTEMA_VENDAS_ROUTES.Pedidos.Ranking.Geral.path,
                component: cTEMA_VENDAS_ROUTES.Pedidos.Ranking.Geral.component,
              },
              {
                name: cTEMA_VENDAS_ROUTES.Pedidos.Ranking.Itens.name,
                path: cTEMA_VENDAS_ROUTES.Pedidos.Ranking.Itens.path,
                component: cTEMA_VENDAS_ROUTES.Pedidos.Ranking.Itens.component,
              },
            ],
          },

          {
            name: cTEMA_VENDAS_ROUTES.Pedidos.Acompanhamento.name,
            path: cTEMA_VENDAS_ROUTES.Pedidos.Acompanhamento.path,
            children: [
              {
                name: cTEMA_VENDAS_ROUTES.Pedidos.Acompanhamento.Diario.name,
                path: cTEMA_VENDAS_ROUTES.Pedidos.Acompanhamento.Diario.path,
                component: cTEMA_VENDAS_ROUTES.Pedidos.Acompanhamento.Diario.component,
              },

              {
                name: cTEMA_VENDAS_ROUTES.Pedidos.Acompanhamento.Semanal.name,
                path: cTEMA_VENDAS_ROUTES.Pedidos.Acompanhamento.Semanal.path,
                component: cTEMA_VENDAS_ROUTES.Pedidos.Acompanhamento.Semanal.component,
              },
              {
                name: cTEMA_VENDAS_ROUTES.Pedidos.Acompanhamento.Quinzenal.name,
                path: cTEMA_VENDAS_ROUTES.Pedidos.Acompanhamento.Quinzenal.path,
                component: cTEMA_VENDAS_ROUTES.Pedidos.Acompanhamento.Quinzenal.component,
              },

              {
                name: cTEMA_VENDAS_ROUTES.Pedidos.Acompanhamento.Mensal.name,
                path: cTEMA_VENDAS_ROUTES.Pedidos.Acompanhamento.Mensal.path,
                component: cTEMA_VENDAS_ROUTES.Pedidos.Acompanhamento.Mensal.component,
              },

              {
                name: cTEMA_VENDAS_ROUTES.Pedidos.Acompanhamento.Trimestral.name,
                path: cTEMA_VENDAS_ROUTES.Pedidos.Acompanhamento.Trimestral.path,
                component: cTEMA_VENDAS_ROUTES.Pedidos.Acompanhamento.Trimestral.component,
              },

              {
                name: cTEMA_VENDAS_ROUTES.Pedidos.Acompanhamento.Semestral.name,
                path: cTEMA_VENDAS_ROUTES.Pedidos.Acompanhamento.Semestral.path,
                component: cTEMA_VENDAS_ROUTES.Pedidos.Acompanhamento.Semestral.component,
              },

              {
                name: cTEMA_VENDAS_ROUTES.Pedidos.Acompanhamento.Anual.name,
                path: cTEMA_VENDAS_ROUTES.Pedidos.Acompanhamento.Anual.path,
                component: cTEMA_VENDAS_ROUTES.Pedidos.Acompanhamento.Anual.component,
              },
            ],
          },

          {
            name: cTEMA_VENDAS_ROUTES.Pedidos.Evolucao.name,
            path: cTEMA_VENDAS_ROUTES.Pedidos.Evolucao.path,
            component: cTEMA_VENDAS_ROUTES.Pedidos.Evolucao.component,
          },

          {
            name: cTEMA_VENDAS_ROUTES.Pedidos.CarteiraDeClientes.name,
            path: cTEMA_VENDAS_ROUTES.Pedidos.CarteiraDeClientes.path,
            component: cTEMA_VENDAS_ROUTES.Pedidos.CarteiraDeClientes.component,
          },

          {
            name: cTEMA_VENDAS_ROUTES.Pedidos.FaturadosDevolvidosCancelados.name,
            path: cTEMA_VENDAS_ROUTES.Pedidos.FaturadosDevolvidosCancelados.path,
            component: cTEMA_VENDAS_ROUTES.Pedidos.FaturadosDevolvidosCancelados.component,
          },

          {
            name: cTEMA_VENDAS_ROUTES.Pedidos.CurvaABC.name,
            path: cTEMA_VENDAS_ROUTES.Pedidos.CurvaABC.path,
            component: cTEMA_VENDAS_ROUTES.Pedidos.CurvaABC.component,
          },
        ],
      },

      {
        name: cTEMA_VENDAS_ROUTES.Assistencias.name,
        path: cTEMA_VENDAS_ROUTES.Assistencias.path,
        redirect: { name: cTEMA_VENDAS_ROUTES.Assistencias.VisaoGeral.name },
        children: [
          {
            name: cTEMA_VENDAS_ROUTES.Assistencias.VisaoGeral.name,
            path: cTEMA_VENDAS_ROUTES.Assistencias.VisaoGeral.path,
            component: cTEMA_VENDAS_ROUTES.Assistencias.VisaoGeral.component,
          },

          {
            name: cTEMA_VENDAS_ROUTES.Assistencias.ComparativoVendasxAssistencias.name,
            path: cTEMA_VENDAS_ROUTES.Assistencias.ComparativoVendasxAssistencias.path,
            component: cTEMA_VENDAS_ROUTES.Assistencias.ComparativoVendasxAssistencias.component,
          },

          {
            name: cTEMA_VENDAS_ROUTES.Assistencias.AnaliseGeografica.name,
            path: cTEMA_VENDAS_ROUTES.Assistencias.AnaliseGeografica.path,
            component: cTEMA_VENDAS_ROUTES.Assistencias.AnaliseGeografica.component,
          },

          {
            name: cTEMA_VENDAS_ROUTES.Assistencias.MetaVendas.name,
            path: cTEMA_VENDAS_ROUTES.Assistencias.MetaVendas.path,
            children: [
              {
                name: cTEMA_VENDAS_ROUTES.Assistencias.MetaVendas.Especifico.name,
                path: cTEMA_VENDAS_ROUTES.Assistencias.MetaVendas.Especifico.path,
                children: [
                  {
                    name: cTEMA_VENDAS_ROUTES.Assistencias.MetaVendas.Especifico.MetaPorConsultor.name,
                    path: cTEMA_VENDAS_ROUTES.Assistencias.MetaVendas.Especifico.MetaPorConsultor.path,
                    component: cTEMA_VENDAS_ROUTES.Assistencias.MetaVendas.Especifico.MetaPorConsultor.component,
                  },

                  {
                    name: cTEMA_VENDAS_ROUTES.Assistencias.MetaVendas.Especifico.MetaPorSupervisor.name,
                    path: cTEMA_VENDAS_ROUTES.Assistencias.MetaVendas.Especifico.MetaPorSupervisor.path,
                    component: cTEMA_VENDAS_ROUTES.Assistencias.MetaVendas.Especifico.MetaPorSupervisor.component,
                  },
                ],
              },

              {
                name: cTEMA_VENDAS_ROUTES.Assistencias.MetaVendas.Geral.name,
                path: cTEMA_VENDAS_ROUTES.Assistencias.MetaVendas.Geral.path,
                children: [
                  {
                    name: cTEMA_VENDAS_ROUTES.Assistencias.MetaVendas.Geral.MetaPorConsultor.name,
                    path: cTEMA_VENDAS_ROUTES.Assistencias.MetaVendas.Geral.MetaPorConsultor.path,
                    component: cTEMA_VENDAS_ROUTES.Assistencias.MetaVendas.Geral.MetaPorConsultor.component,
                  },

                  {
                    name: cTEMA_VENDAS_ROUTES.Assistencias.MetaVendas.Geral.MetaPorSupervisor.name,
                    path: cTEMA_VENDAS_ROUTES.Assistencias.MetaVendas.Geral.MetaPorSupervisor.path,
                    component: cTEMA_VENDAS_ROUTES.Assistencias.MetaVendas.Geral.MetaPorSupervisor.component,
                  },
                ],
              },
            ],
          },
        ],
      },

      {
        name: cTEMA_VENDAS_ROUTES.Personalizado.name,
        path: cTEMA_VENDAS_ROUTES.Personalizado.path,
        redirect: { name: cTEMA_VENDAS_ROUTES.Personalizado.Gerenciador.name },
        children: [
          {
            name: cTEMA_VENDAS_ROUTES.Personalizado.Gerenciador.name,
            path: cTEMA_VENDAS_ROUTES.Personalizado.Gerenciador.path,
            component: cTEMA_VENDAS_ROUTES.Personalizado.Gerenciador.component,
          },

          {
            name: cTEMA_VENDAS_ROUTES.Personalizado.Dashboard.name,
            path: cTEMA_VENDAS_ROUTES.Personalizado.Dashboard.path,
            props: cTEMA_VENDAS_ROUTES.Personalizado.Dashboard.props,
            component: cTEMA_VENDAS_ROUTES.Personalizado.Dashboard.component,
          },
        ],
      },
    ],
  },
];
